module.exports = __webpack_public_path__ + "static/media/01.13939eb8.jpg";